import { render } from "./PaymentSpecifications.vue?vue&type=template&id=3f5c5fc1"
import script from "./PaymentSpecifications.vue?vue&type=script&lang=js"
export * from "./PaymentSpecifications.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__